<div class="dialog-content">
  <form class="k-form" [formGroup]="tagForm()">
    <kendo-formfield orientation="horizontal">
      <kendo-label
        class="!k-align-items-start"
        [for]="formControlNames.Name"
        text="Tagname"
      ></kendo-label>
      <kendo-textbox
        showErrorIcon="initial"
        id="holidayName"
        [formControlName]="formControlNames.Name"
        #name
      >
      </kendo-textbox>
      <kendo-formerror>Error: Full Name is required</kendo-formerror>
    </kendo-formfield>

    <kendo-formfield orientation="horizontal">
      <kendo-label text="Tag-Farbe" [for]="tagColor"></kendo-label>
      <kendo-colorpicker
        [paletteSettings]="{ palette: defaultPalette }"
        class="k-w-24"
        [formControlName]="formControlNames.Color"
        [views]="['palette']"
        [clearButton]="false"
        #tagColor
      >
      </kendo-colorpicker>
    </kendo-formfield>
  </form>
</div>

<footer class="k-d-flex k-justify-content-between">
  <button (click)="close()" kendoButton size="large" themeColor="secondary" class="k-mr-4 !k-pr-4">
    <span class="custom-symbol close k-mr-3"></span>
    <span class="label">Schließen</span>
  </button>

  <button kendoButton (click)="submit()" class="!k-pr-4" themeColor="base" size="large">
    <fa-icon class="update k-text-white k-mr-3" [icon]="faPenToSquare"></fa-icon>
    <span class="label">Aktualisieren</span>
  </button>
</footer>
